import { render, staticRenderFns } from "./IconTrainings.vue?vue&type=template&id=cf591816&functional=true&"
import script from "./IconTrainings.vue?vue&type=script&lang=js&"
export * from "./IconTrainings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports